import GetExpenseDataLocal from "./GetExpenseDataInLocal";
import * as actionType from "../../../context/actions";

const AddExpenseDataInLocal = async (state, dispatch, expenseData) => {
    try {
        // Retrieve existing invoices from localStorage
        const existingData = JSON.parse(localStorage.getItem("LOCAL_EXPENSE")) || [];


        const newExpense = {
            createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            createdById: state?.USERID || null,
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            updatedById: state?.USERID || null,
            companyId: expenseData?.companyId?.toString() || "",
            createdDate: new Date().getTime().toString(),
            amount: expenseData?.amount?.toString() || "",
            expenseCategory: expenseData?.category.toString() || "",
            expenseDate: expenseData?.expenseDate || new Date().toISOString().slice(0, 10), // Defaults to today
            expenseDescription: expenseData?.description.toString() || "",
            expenseId: expenseData?.expenseId?.toString() || "",
            paymentMethod: expenseData?.paymentMethod || "Cash",
            expenseName: expenseData?.expenseName || "",
            updateDate: expenseData?.updateDate?.toString() || new Date().getTime().toString(),
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            currency: expenseData?.currency?.toString() || ""
        };

        // Append new invoice to existing data
        existingData.push(newExpense);

        // Save updated invoices back to localStorage
        localStorage.setItem("LOCAL_EXPENSE", JSON.stringify(existingData));

        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Fetch updated invoice data
        await GetExpenseDataLocal(state, dispatch);

        return { success: true, message: "New expense added successfully!" };
    } catch (error) {
        return { success: false, message: error.message || error };
    }
};

export default AddExpenseDataInLocal;
